import { createAsyncThunk } from '@reduxjs/toolkit'
import { API_BASE_URL, API_KEY_ID, API_KEY_SECRET } from '../../constant'
import axios from 'axios'

/**
 * Fetch Cart Details from the Database using user_id
 */
export const fetchCart = createAsyncThunk('cart/fetchCart', async (user_id, { rejectWithValue }) => {
    try {
        const res = await axios.get(`${API_BASE_URL}/cart`, {
            params: { user_id },
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET,
            },
        });
        // console.log("Cart action fetch results:", res.data)
        return res.data;  // Returning the cart details from the response
    } catch (error) {
        console.log("Cart action fetch results failed:", error.response?.data)
        return rejectWithValue(error.response?.data || error.message);
    }
});

/**
 * Update Cart with user_id (either logged-in or guest)
 */
export const updateCart = createAsyncThunk('cart/updateCart', async (cartData, { rejectWithValue }) => {
    try {
        // console.log("Action updateCart Details:", cartData)
        const res = await axios.post(`${API_BASE_URL}/cart`, {
            // user_id,
            ...cartData,
        }, {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET,
            },
        });
        return res.data.cart;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

/**
 * Add Product to Cart
 */
export const addProductToCart = createAsyncThunk('cart/addProductToCart', async (cartData, { rejectWithValue }) => {
    try {
        const res = await axios.post(`${API_BASE_URL}/cart`, cartData, {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET,
            },
        });
        // console.log("Action data:", res.data.cart)
        return res.data.cart;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

/**
 * Clear Cart with user_id
 */
export const clearCart = createAsyncThunk('cart/clearCart', async (user_id, { rejectWithValue }) => {
    try {
        const res = await axios.delete(`${API_BASE_URL}/cart/clear`, {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET,
            },
            params: { user_id },
        });

        return res.data;
    } catch (error) {
        const errorMessage = error.response ? error.response.data.message || error.response.data : error.message;
        return rejectWithValue(errorMessage);
    }
});